
export default {
  data() {
    return {
      options: [
        {
          name: 'name',
          label: 'Location name',
          type: 'text',
        },
        {
          name: 'locationCoordinates',
          label: 'Coordinates',
          type: 'coordinates',
        },
      ],
    }
  },
  mounted() {
    this.$nextTick(() => {
      if (
        this.$refs.location &&
        this.$refs.location.items &&
        this.$refs.location.items[0].locationCoordinates &&
        this.$refs.location.items[0].locationCoordinates.lat &&
        this.$refs.location.items[0].locationCoordinates.long &&
        this.$refs.map &&
        this.$refs.map.$children[0]
      ) {
        const lat = this.$refs.location.items[0].locationCoordinates.lat
        const long = this.$refs.location.items[0].locationCoordinates.long

        const map = this.$refs.map.$children[0]
        map.setZoom(15)
        map.setCenter([lat, long])
      }
    })
  },
}
